import Swal, { SweetAlertIcon } from 'sweetalert2'
import './style.css'
import 'animate.css'

const ToastAlert = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  iconColor: 'white',
  customClass: {
    container: 'swal-toast-container',
    popup: 'colored-toast',
  },
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer
    toast.onmouseleave = Swal.resumeTimer
  },
})

const iconTitleMap: { [key in SweetAlertIcon]: string } = {
  success: 'Successful',
  error: 'Something Went Wrong',
  warning: 'Warning',
  info: 'Information',
  question: 'Are You Sure?',
}

const showToast = (icon: SweetAlertIcon, text: string, position?: string): void => {
  const title = iconTitleMap[icon] || 'Success'

  ToastAlert.fire({
    icon: icon,
    title: title,
    text: text,
    position: (position as any) || 'top-end',
    showClass: {
      popup: `
        animate__animated
        animate__fadeInRight
        animate__faster
      `,
    },
    hideClass: {
      popup: `
        animate__animated
        animate__fadeOutRight
        animate__faster
      `,
    },
  })
}

export default showToast
